import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from 'src/app/globals';
import { CRMAtributo } from 'src/app/models/crm/crmatributo';

@Injectable({
  providedIn: 'root'
})
export class CrmatributoService {

  constructor(private http: HttpClient) { }

  consultarAtributos() {
    return this.http.get<CRMAtributo[]>(globals.apiUrl + '/api/CRMAtributo/Lista');
  }

  consultarAtributosComPaginacao(descricao: string, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao, statusCadastro) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao);

    if (descricao.trim() !== '') {
      parametros = parametros.set('descricao', descricao);
    }

    if (statusCadastro !== null) {
      parametros = parametros.set('statusCadastro', statusCadastro);
    }

    return this.http.get<any>(globals.apiUrl + '/api/CRMAtributo/ListaPag',
      {
        params: parametros
      });
  }

  consultarPorIdAtributo(idAtributo) {
    return this.http.get<any>(globals.apiUrl + '/api/CRMAtributo/Buscar',
      {params: new HttpParams().set('id', idAtributo)});
  }

  salvar(atributo: CRMAtributo) {
    return this.http.post(globals.apiUrl + '/api/CRMAtributo/Salvar', atributo);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/CRMAtributo/Excluir',
      {params: new HttpParams().set('id', id)});
  }

  consultarPorIdOportunidade(idOportunidade) {
    return this.http.get<any>(globals.apiUrl + '/api/CRMAtributo/ListaPorOportunidade',
      {params: new HttpParams().set('idOportunidade', idOportunidade)});
  }

  verificarVinculoOportunidade(idAtributo) {
    return this.http.get<any>(globals.apiUrl + '/api/CRMAtributo/VerificaVinculoOportunidade',
      {params: new HttpParams().set('id', idAtributo)});
  }
}
